import { Controller } from '@hotwired/stimulus';

const DIVISIONS = [
  { date: false, amount: 60, name: 'seconds' }, // per minute
  { date: false, amount: 60, name: 'minutes' }, // per hour
  { date: false, amount: 24, name: 'hours' }, // per day
  { date: true, amount: 365, name: 'days' }, // per year
  { date: true, amount: Number.POSITIVE_INFINITY, name: 'years' },
];

export default class extends Controller {
  static values = {
    format: { type: String, default: 'time' },
  };

  // Lazily build the formatter so an empty <html lang=""> (the case on the
  // Trestle admin layout) does not crash the module at import time. Falls
  // back to the runtime's default locale when the page has no lang attr.
  static get formatter() {
    if (!this._formatter) {
      const lang = document.documentElement.lang || undefined;
      this._formatter = new Intl.RelativeTimeFormat(lang, { numeric: 'auto' });
    }
    return this._formatter;
  }

  connect() {
    const dateTime = new Date(this.element.dateTime);
    const duration = this.duration(dateTime);

    this.element.innerHTML = this.formatDuration(duration);
  }

  formatDuration(duration) {
    for (const division of DIVISIONS) {
      if (this.formatValue === 'date' && division.date === false) continue;

      if (Math.abs(duration) < division.amount)
        return this.constructor.formatter.format(
          Math.round(duration),
          division.name,
        );

      duration /= division.amount;
    }
  }

  duration(dateTime) {
    switch (this.formatValue) {
      case 'date':
        return this.durationInDays(dateTime);
      case 'time':
        return this.durationInSeconds(dateTime);
    }
  }

  durationInDays(dateTime) {
    const today = new Date();

    // Ensure that both dates have the same time
    today.setHours(0, 0, 0, 0);
    dateTime.setHours(0, 0, 0, 0);

    return (dateTime - today) / 1000 / (60 * 60 * 24);
  }

  durationInSeconds(dateTime) {
    return (dateTime - new Date()) / 1000;
  }
}
